import React, { useState, useEffect } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";
import ThirdBar from "../../../../components/AdminComponents/ThirdBar";
import { EditTwoTone, HistoryOutlined, UserOutlined } from "@ant-design/icons";
import Axios from "../../../../api/Axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Table, Switch, Pagination, Avatar, Spin } from "antd";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";

const TemplateLogs = () => {
  const { id } = useParams();
  const namingData = useSelector((state) => state.orgdeatil);
  const thirdMenuData = [
    {
      path: `/ca-admin/organization/communications/templates/edit-template/${id}`,
      name: namingData?.templateName,
      icon: (
        <EditTwoTone
          style={{ fontSize: "15.5px", marginRight: "2.5px", margintop: "1px" }}
        />
      ),
    },
    {
      path: `/ca-admin/organization/communications/templates/${id}/logs`,
      name: "TEMPLATE LOGS",
      icon: (
        <HistoryOutlined
          style={{ fontSize: "15.5px", marginRight: "2.5px", margintop: "1px" }}
        />
      ),
    },
  ];

  const userInfo = useSelector((state) => state.user);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [itemsLength, setItemsLength] = useState();
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    active: true,
    url: `/maillogslist/${userInfo?.data?.organization?.id}/?template_id=${id}`,
    search: "",
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, url, search, active } = filterData;
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `&page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        //console.log(res.data.results);
        setItemsLength(res.data.count);
        setData(res.data.results);
        setLoading(false);

        //console.log(data);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const columns = [
    {
      title: capitalizeWords("SENT BY"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt={record?.sent_by?.full_name}
            src={record?.sent_by?.profile_pic || null}
            icon={!record?.sent_by?.profile_pic && <UserOutlined />}
            size="small"
          />
          <span style={{ marginLeft: 8 }}>
            {record?.sent_by?.full_name || "Unknown"}
          </span>
        </div>
      ),
    },
    {
      title: capitalizeWords("RECEIVED BY"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt={record?.user?.full_name}
            src={record?.user?.profile_pic || null}
            icon={!record?.user?.profile_pic && <UserOutlined />}
            size="small"
          />
          <span style={{ marginLeft: 8 }}>{record?.user?.full_name}</span>
        </div>
      ),
    },

    {
      title: capitalizeWords("TEMPLATE USED"),
      dataIndex: "templateUsed",
      key: "templateUsed",
      width: 250,
      render: (_, record) => (
        <span style={{ marginLeft: 8 }}>{record?.template?.title}</span>
      ),
    },
    {
      title: capitalizeWords("EMAIL TYPE"),
      dataIndex: "type",
      key: "type",
      width: 150,
    },
    {
      title: capitalizeWords("EMAIL STATUS"),
      dataIndex: "email_status",
      key: "email_status",
      width: 150,
    },
    {
      title: capitalizeWords("SENT TIME"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (text, record) => {
        const date = new Date(record?.updated_at);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        if (record.updated_at) {
          return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
  ];

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  return (
    <CaSideNav props={CaAdminMenu}>
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <ThirdBar menuItems={thirdMenuData} />
      <CommonTopDetails
        title={active ? "Template Log Summary" : "Inactive Logs"}
        titleSuffix={`${itemsLength || 0} Log(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        marginPass="15px"
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            // onChange={handleSwitchChange}
            disabled={loading}
            checkedChildren="ACTIVE"
            unCheckedChildren="INACTIVE"
          />
        }
      />

      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          size="small"
          rowKey="id"
          bordered
          className="table-container"
          pagination={false}
          style={{ margin: "1rem" }}
          scroll={{
            y: `${remainingViewportHeight(36)}px`,
            x: 1000,
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
    </CaSideNav>
  );
};

export default TemplateLogs;
